import { JobApplication } from './../../model/jobapplication';
import { Field, Active } from './../../model/bwmconfig';
import { formatDate } from '@angular/common';
import { Input, Directive, Output, EventEmitter } from '@angular/core';

@Directive()
export abstract class AbstractFieldComponent<T> {
    @Input() field?: Field;
    @Input() jobapplication?: JobApplication;
    @Input() readonly = false;
    @Output() readonly valueChange = new EventEmitter<T>();

    readonly currentDate: string = formatDate( Date.now(), 'yyyy-MM-dd', 'de-DE' );

    constructor( readonly i18nIdentifier: string ) { }

    isMandatory(): boolean {
        return this.field?.mandatory === Active.Y;
    }

    abstract set value( t: T | undefined );
    abstract get value(): T | undefined;

    onModelChange( t: T ): void {
        this.valueChange.emit( t );
    }
}
